module.exports = __webpack_public_path__ + "static/media/volant-marron.ca4f5a96.png";